import Kfit from '../integrations/Kfit';

export const alipayCreateTransactionalQrCode = params =>
  Kfit.post('/v5/alipay/create_transactional_qr_code', params).then(res => res);

export const alipayRefund = params =>
  Kfit.post('/v5/alipay/refund', params).then(res => res);
